import { render } from "./UserIndexView.vue?vue&type=template&id=0bf641a6&scoped=true"
import script from "./UserIndexView.vue?vue&type=script&lang=js"
export * from "./UserIndexView.vue?vue&type=script&lang=js"

import "./UserIndexView.vue?vue&type=style&index=0&id=0bf641a6&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf641a6"]])

export default __exports__